import React from "react";
import { cva } from "class-variance-authority";
import { Center } from "@/shared/ui/Blocks";

export interface StatusBadgeProps {
  label: string;
  className?: string;
  visible?: boolean;
  variant?:
    | "success"
    | "warning"
    | "neutral"
    | "primary"
    | "successFilled"
    | "warningFilled"
    | "neutralFilled"
    | "primaryFilled";
}

const statusBadgeStyles = cva(
  "border border-solid rounded-md py-1 px-3 text-xs w-fit h-[30px]",
  {
    variants: {
      variant: {
        success: "border-green-500 text-green-500",
        warning: "border-orange-500 text-orange-500",
        neutral: "border-grey-300 text-grey-700",
        primary: "border-primary text-primary",
        primaryFilled: "border-primary text-primary bg-blue-100 px-2 h-[24px]",
        neutralFilled:
          "border-grey-300 text-grey-700 bg-grey-100 px-2 h-[24px]",
        warningFilled:
          "border-orange-500 text-orange-500 bg-orange-100 px-2 h-[24px]",
        successFilled:
          "border-green-500 text-green-500 bg-green-100 px-2 h-[24px]",
      },
    },
    defaultVariants: {
      variant: "neutral",
    },
  }
);

function StatusBadge(props: StatusBadgeProps) {
  const {
    label,
    className,
    visible = true,
    variant = "neutral",
    ...rest
  } = props;

  if (!visible || !label) return null;

  return (
    <Center className={statusBadgeStyles({ variant, className })} {...rest}>
      <span className="text-nowrap ">{label}</span>
    </Center>
  );
}

export { StatusBadge };
